import React, { ComponentPropsWithRef, ElementType, ReactNode } from 'react';
import classnames from 'classnames';

import { ReactComponent as MarkerSVG } from '../../../assets/icons/marker.svg';

import './Pin.scss';

export interface PinProps extends ComponentPropsWithRef<ElementType> {
  className?: string;
  children?: ReactNode;
}

const Pin = ({ className, children, ...props }: PinProps) => (
  <button className={classnames('pin', className)} {...props}>
    <MarkerSVG />
    <div className="pin__content">{children}</div>
  </button>
);

export default Pin;
